/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Usage_Status_Headline_NormalInputs */



/**
* | output |
* | --- |
* | "You've spent {used} of {max} this billing period." |
*
* @param {Usage_Status_Headline_NormalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_status_headline_normal = /** @type {((inputs: Usage_Status_Headline_NormalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Status_Headline_NormalInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie haben in dieser Abrechnungsperiode ${i?.used} von ${i?.max} ausgegeben.`)
	return /** @type {LocalizedString} */ (`You've spent ${i?.used} of ${i?.max} this billing period.`)
});